import { EditOutlined } from "@mui/icons-material";
import ActivityNote from "../../Activities/ActivityNote";
import React from "react";
import { IconButton } from "@mui/material";
import PaidTaskCaseHead from "./PaidTaskCaseHead";
import { Link } from "react-router-dom";
import { getCaseLinkByBackofficeCase } from "../../../services/Product/ProductService/productService";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import { PaidTask } from "../../../types/PaidTask";

type PaidTaskCaseProps = {
  paidTask: PaidTask;
};

const PaidTaskCase = ({ paidTask }: PaidTaskCaseProps) => {
  const currentUser = useCurrentUser();

  return (
    <>
      <PaidTaskCaseHead
        paidTask={paidTask}
        actions={
          <>
            <IconButton
              component={Link}
              to={
                getCaseLinkByBackofficeCase(paidTask.backofficeCase, currentUser.isExternal ? "/extern" : "") +
                "/ausschreibung/" +
                paidTask.id
              }
              size="large"
            >
              <EditOutlined />
            </IconButton>
          </>
        }
      />
      <ActivityNote noteContent={paidTask.description} />
    </>
  );
};

export default PaidTaskCase;
